import { CANDIDATE_AE_FOLDER_STATUS, CANDIDATE_KYC_STATUS } from "@core/constants";

export const ICandidateKyc = Object.freeze({
  AeFolderStatus: "status",
  isKycDocumentRequired: "is_kyc_required_document",
  status: "status_kyc",
  kycAuthorize: "kyc_authorize",
});

export class CandidateKycModel {
  constructor(data = {}) {
    this[ICandidateKyc.AeFolderStatus] = data[ICandidateKyc.AeFolderStatus];
    this[ICandidateKyc.isKycDocumentRequired] = data[ICandidateKyc.isKycDocumentRequired];
    this[ICandidateKyc.status] = data[ICandidateKyc.status];
    this[ICandidateKyc.kycAuthorize] = data[ICandidateKyc.kycAuthorize];
  }

  getStatus() {
    return this[ICandidateKyc.status];
  }

  getAeFolderStatus() {
    return this[ICandidateKyc.AeFolderStatus];
  }

  aeFolderIsVerifiedOrPending() {
    return (
      this.getAeFolderStatus() === CANDIDATE_AE_FOLDER_STATUS.STATUS_VERIFIED ||
      this.getAeFolderStatus() === CANDIDATE_AE_FOLDER_STATUS.STATUS_PENDING_INTERNAL_VERIFICATION
    );
  }

  kycIsVerified() {
    return this.getStatus() === CANDIDATE_KYC_STATUS.VERIFIED;
  }

  kycIsRefused() {
    return this.getStatus() === CANDIDATE_KYC_STATUS.UNVERIFIED;
  }

  kycIsPending() {
    return this.getStatus() === CANDIDATE_KYC_STATUS.PENDING;
  }

  kycIsWaitingForAcceptance() {
    return this.getStatus() === CANDIDATE_KYC_STATUS.WAITING_FOR_ACCEPTANCE;
  }

  kycIsNonExistent() {
    return this.getStatus() === CANDIDATE_KYC_STATUS.NON_EXISTENT;
  }

  isAdditionalFileRequired() {
    return this[ICandidateKyc.isKycDocumentRequired];
  }

  isKycAuthorized() {
    return this[ICandidateKyc.kycAuthorize];
  }
}
